import { render, staticRenderFns } from "./WishListIcon.vue?vue&type=template&id=1e86dbea&"
import script from "./WishListIcon.js?vue&type=script&lang=js&"
export * from "./WishListIcon.js?vue&type=script&lang=js&"
import style0 from "./WishListIcon.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./WishListIcon.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fproduct%2FWishListIcon%2FWishListIcon.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports